import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a4016ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "doc-page" }

import DocumentViewer from '@/components/document/DocumentViewer.vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDoc',
  setup(__props) {

const docUrl = ref(
  'https://d1bnvx5vhcnf8w.cloudfront.net/curriculum/Oct%202020%20%28Edition%205%29/General/edition_5_-_general_english_g6.pdf',
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DocumentViewer, { "doc-path": docUrl.value }, null, 8, ["doc-path"])
  ]))
}
}

})